//from https://schneidenbach.gitbooks.io/typescript-cookbook/content/nameof-operator.html

export const nameofFactory =
  <T>() =>
  (name: keyof T) =>
    name;
